const STORAGE_KEY = 'unit13-access-granted';

function storeUnit13Access() {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch (e) {}
}

function hideUnit13Gate() {
  document.documentElement.classList.add('unit13-access-granted');
  document.body?.classList.remove('unit13-access-locked');

  const gate = document.querySelector('[data-unit13-access-gate]');
  if (gate) {
    gate.setAttribute('aria-hidden', 'true');
    gate.style.pointerEvents = 'none';
  }
}

function unlockUnit13(gate) {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  storeUnit13Access();

  if (reduceMotion) {
    hideUnit13Gate();
    return;
  }

  // The gate becomes a thin horizontal seam while the storefront resolves
  // underneath it. No extra copy or decorative loading screen is introduced.
  root.classList.add('unit13-access-unlocking');

  window.setTimeout(() => {
    root.classList.add('unit13-just-unlocked');
  }, 180);

  window.setTimeout(() => {
    hideUnit13Gate();
    root.classList.remove('unit13-access-unlocking');
  }, 920);

  window.setTimeout(() => {
    root.classList.remove('unit13-just-unlocked');
  }, 1500);
}

function updateTypingProgress(form, input) {
  const length = Math.min(13, input.value.length);
  form.style.setProperty('--u13-access-progress', String(length / 13));
  form.classList.toggle('has-value', length > 0);
}

function initUnit13Access() {
  const gate = document.querySelector('[data-unit13-access-gate]');
  if (!gate) return;

  let granted = false;
  try {
    granted = sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {}

  if (granted) {
    hideUnit13Gate();
    return;
  }

  document.body?.classList.add('unit13-access-locked');

  const form = gate.querySelector('[data-unit13-access-form]');
  const input = gate.querySelector('[data-unit13-access-input]');
  const error = gate.querySelector('[data-unit13-access-error]');

  if (!form || !input) return;

  updateTypingProgress(form, input);

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!input.value.trim()) {
      if (error) error.hidden = false;
      input.focus();
      return;
    }

    if (error) error.hidden = true;
    input.blur();
    form.classList.add('is-accepted');
    unlockUnit13(gate);
  });

  input.addEventListener('input', () => {
    if (error && input.value.trim()) error.hidden = true;
    updateTypingProgress(form, input);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUnit13Access, { once: true });
} else {
  initUnit13Access();
}
